//TODO: This all is BAD. We need to fix these styles and make them more modular and reusable.

.aiAssistant {
  display: flex;
  flex-direction: column;
  gap: 18px;
  position: relative;
  background: #fafafa;

  &__messageList {
    display: flex;
    width: 100%;
    min-height: calc(100vh - 385px);
    margin-top: 32px;
  }

  &__mobileActions {
    padding: 0 12px;
    position: sticky;
    top: 120px;

    @media (min-width: 1024px) {
      display: none;
    }
  }

  &__desktopActions {
    display: none;

    @media (min-width: 1024px) {
      display: block;
      padding-right: 12px;
    }
  }

  &__messagesWrapper {
    width: 100%;

    @media (min-width: 1024px) {
      width: calc(100% - 312px);
    }
  }

  &__promptArea {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    background: linear-gradient(#fff6, #fff);
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}